import { RecipesListSectionProps } from '../../components/RecipesListSection'
import { Recipe } from '../../types/fam-graphql'

import { recipesCardListTransformer, recipesFiltersTransformer } from '.'

export const recipesListTransformer = (params: {
  t: any
  filters: { [key: string]: any }
  handleFilterChange: (field: any, values: any) => void
  recipes: Recipe[]
  loadMoreFunction?: any
  loadPreviousFunction?: any
  handleApplyFilter: () => void
  handleCloseFilter: () => void
  handleSwitchCourse?: (id: string) => void
  ignoredFilters: string[]
  recipeMainComponent?: {
    label: string
    id: string
  }
  tcVars?: {
    chapter2: string
    chapter3: string
  }
  resultsRef?: any
  isFromSwitchCourse?: boolean
  selectedSide?: string
}): RecipesListSectionProps => {
  const {
    t,
    filters,
    handleFilterChange,
    recipes,
    loadMoreFunction,
    loadPreviousFunction,
    handleApplyFilter,
    handleCloseFilter,
    handleSwitchCourse,
    ignoredFilters = [],
    recipeMainComponent,
    tcVars,
    resultsRef,
    isFromSwitchCourse,
    selectedSide,
  } = params

  return {
    resultsRef,
    recipesFiltersProps: recipesFiltersTransformer({
      t,
      filters,
      handleFilterChange,
      handleApplyFilter,
      handleCloseFilter,
      ignoredFilters,
      recipeMainComponent,
      tcVars,
      selectedSide,
    }),
    recipeCardListProps: recipesCardListTransformer({
      t,
      recipes,
      loadMoreFunction,
      loadPreviousFunction,
      handleSwitchCourse,
      isFromRecipeList: true,
      isFromSwitchCourse,
      tcVars,
    }),
  }
}
